import { makeAutoObservable, runInAction } from "mobx";
import api, { GetUserParameters, GetUserRes, PostAuthLoginParameters, PutUserParameters, PutUserRes } from "../api";
import {
  RequestStatus,
  createRequestStatus,
  handleRequest
} from "../toll/toolRequestStatus"; // 根据你的具体路径
import i18n from "../I18n";
import moment from "moment";
import 'moment/locale/zh-cn';
import 'moment/locale/zh-hk';


class UserStore {
  userData?: GetUserRes;
  userDataMap: { [x: string]: GetUserRes | undefined } = {};
  userStatusMap: { [x: string]: RequestStatus } = {}
  userStatus = createRequestStatus();
  updateUserStatus = createRequestStatus();
  language: GetUserRes['communicationLanguage'] = 'zh-HK'

  constructor () {
    makeAutoObservable(this);
  }

  setLanguage = (language: GetUserRes['communicationLanguage']) => {
    this.language = language
    i18n.changeLanguage(language);
    localStorage.setItem('jwt_language', language ?? 'en');

    // 设置 moment 的语言
    let momentLocale = 'en';
    if (language === 'zh-CN') {
      momentLocale = 'zh-cn';
    } else if (language === 'zh-HK') {
      momentLocale = 'zh-hk';
    }

    moment.locale(momentLocale);

    if (this.userData?.id && this.userData.communicationLanguage !== language) {
      this.updateUser({ id: this.userData?.id, communicationLanguage: language })
    }
  }

  resetUserStatus() {
    this.userStatus = createRequestStatus()
  }

  getUser = async (params: GetUserParameters = { id: "me" }) => {
    await handleRequest<GetUserRes>(
      this.userStatus,
      () => api.GetUser({ id: params.id }),
      (res) => {
        this.userData = res;
        this.setLanguage(this.userData?.communicationLanguage ?? 'zh-HK')
        const authStore = require("./authStore").default; // 延迟引入
        authStore.loggedIn = true
      },
      "获取用户失败"
    );
  };

  getUserMap = async (params: GetUserParameters = { id: "me" }) => {

    if (!this.userStatusMap[params.id]) {
      this.userStatusMap[params.id] = createRequestStatus()
    }

    await handleRequest<GetUserRes>(
      this.userStatusMap[params.id],
      () => api.GetUser({ id: params.id }),
      (res) => {
        this.userDataMap[params.id] = res;
      },
      "获取用户失败"
    );
  };

  updateUser = async (params: PutUserParameters) => {
    await handleRequest<PutUserRes>(
      this.updateUserStatus,
      () => api.PutUser(params),
      (res) => {

      },
      "更新用户信息失败"
    );
  }

}

const userStore = new UserStore();


export default userStore;
